import type { BookingAccess } from '@optionway/models';

interface BookingAccessStore {
  bookingAccess?: BookingAccess;
}

export const useBookingAccessStore = defineStore('booking-access', {
  state: (): BookingAccessStore => ({
    bookingAccess: undefined,
  }),
});
